import { Injectable } from '@angular/core';

import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";

import { AuthService, Roles } from '../../shared/authentication/auth.service';


@Injectable()
export class MenuService {

    menuItems: Array<any>;

    constructor(private authService: AuthService) {
        this.menuItems = [];
    }

    addMenu(items: Array<{
        text: string,
        roles?: Array<Roles>,
        heading?: boolean,
        link?: string,
        image?: string,
        active_image?: string,
        translate?: string,
        submenu?: Array<any>
    }>) : Observable<any> {

        this.menuItems = [];
        let menuSubject = new Subject();

        this.authService.getUser().toPromise()
            .then(user => {

                this.menuItems = items
                    .filter((item:any) => {
                        return !Array.isArray(item.roles) ||
                                item.roles.length === 0 ||
                                item.roles.indexOf(user.organizations[0].role) != -1 
                    });

                menuSubject.next({menu: this.menuItems});
            });

        return menuSubject;
    }

    getMenu() {
        return this.menuItems;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/menu/menu.service.ts